// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionSelection.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ExpressionSelection component
 */

import React from 'react';
import { observer } from 'mobx-react';
import CalculatedFieldConstants from 'logic/data/Izenda.CalculatedFieldConstants';
import MainContent from 'share/components/layout/Izenda.MainContent';
import { Tabs, Tab } from 'share/components/controls/Izenda.Tab';
import Panel from 'share/components/controls/Izenda.Panel';
import FieldNameTab from './Izenda.FieldNameTab';
import FunctionOperatorTab from './Izenda.FunctionOperatorTab';

@observer
class ExpressionSelection extends React.Component {
  static displayName = 'ExpressionSelection';
  static defaultProps = {
    displayDataSource: true
  };

  static propTypes = {
    store: React.PropTypes.object.isRequired
  };

  render() {
    let store = this.props.store;
    const constants = CalculatedFieldConstants.EXPRESSION_SELECTION_TABS;

    return (
      <Panel className="expression-selection-panel">
        <Tabs activeTabKey={constants.fieldName.tabkey} isOnPopover>
          <Tab
            title={constants.fieldName.title}
            tabKey={constants.fieldName.tabkey}>
            <FieldNameTab
              store={store.expressionFieldName}
              onSelect={this.onSelect}
              expressionConfig={this.props.expressionConfig.FIELD_NAME}
              displayDataSource={this.props.displayDataSource}
            />
          </Tab>
          <Tab
            title={constants.functionOperator.title}
            tabKey={constants.functionOperator.tabkey}>
            <FunctionOperatorTab
              store={store.expressionFunctionOperators}
              onSelect={this.onSelect}
            />
          </Tab>
        </Tabs>
      </Panel>
    );
  }

  /**
     * Handle on select of expression.
     */
  onSelect = (value: Object) => {
    this.props.updateValue && this.props.updateValue(value);
  }
}

export default ExpressionSelection;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.ExpressionSelection.js